import { Route, Routes, Outlet, Navigate } from 'react-router-dom'
import { PageLink, PageTitle } from '../../../_metronic/layout/core'
import { OrdersListWrapper } from './orders-list/OrdersList'
import AccountPage from '../../modules/accounts/AccountPage'
import { AccountHeader } from '../../modules/accounts/AccountHeader'
import { Settings } from '../../modules/accounts/components/settings/Settings'
import { Overview } from '../../modules/accounts/components/Overview'

const ordersBreadcrumbs: Array<PageLink> = [
  {
    title: 'Order Management',
    path: '/admin/pages/orders',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]
const accountBreadCrumbs: Array<PageLink> = [
  {
    title: 'Account',
    path: '/admin/pages/orders/overview',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]
const OrdersPage = () => {
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          // path='orders'
          index
          element={
            <>
              <PageTitle breadcrumbs={ordersBreadcrumbs}>Orders list</PageTitle>
              <OrdersListWrapper />
            </>
          }
        />

        <Route
          element={
            <>
              <AccountHeader />
              <Outlet />
            </>
          }
        >
          <Route
            path='overview'
            element={
              <>
                <PageTitle breadcrumbs={accountBreadCrumbs}>Overview</PageTitle>
                <Overview />
              </>
            }
          />
          <Route
            path='settings'
            element={
              <>
                <PageTitle breadcrumbs={accountBreadCrumbs}>Settings</PageTitle>
                <Settings />
              </>
            }
          />
          <Route index element={<Navigate to='/admin/pages/orders/overview' />} />
        </Route>

      </Route>
      <Route index element={<Navigate to='/admin/pages/orders' />} />
    </Routes>
  )
}

export default OrdersPage
